module.exports = __webpack_public_path__ + "img/tik-tok.d35c8d84.svg";